import { render, staticRenderFns } from "./QuilityShop.vue?vue&type=template&id=b2a2ee72&"
import script from "./QuilityShop.vue?vue&type=script&lang=js&"
export * from "./QuilityShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports